export const RESOURCE_CLOUDFRONT_URL = 'https://prd.cdn.bznav.com';

/**
 * 이미지 경로를 반환합니다.
 * - 환경에 따라 `prod` 또는 `test` 경로를 사용합니다.
 * - 브라우저 캐싱을 피하기 위해서 이미지 경로에 timestamp를 추가합니다.
 * @param src 이미지 소스 경로
 * @param type 이미지 타입 (svg, lottie, image, public)
 * @param serviceName 서비스 이름
 * @returns 타임스탬프가 추가된 이미지 경로
 * */

export const getImageSrc = ({ src, type, serviceName = 'care' }: { src: string; type: 'svg' | 'lottie' | 'image' | 'public'; serviceName?: string }) => {
  const now = new Date();
  const timestamp = now.getTime();

  return `${RESOURCE_CLOUDFRONT_URL}/${serviceName}/${type}/${src}?timestamp=${encodeURIComponent(timestamp)}`;
};
